// extracted by mini-css-extract-plugin
export default {"container":"container--2abgady","wrapper":"wrapper--3hBw-pk","fullScreen":"fullScreen--m-H9wdN","text":"text--3dL9KJr","brand":"brand--3fIim-L"};